import { useEffect, useState, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import {
  getCrsReportManagers,
  getCrsReportManagersClear,
} from "../../../redux/reports/actions";
import { SessionKeys } from "../../../utils/AppUtils";
import _ from "lodash";
import CONFIG from "../../../utils/config";
import { CircularProgressbar, buildStyles } from "react-circular-progressbar";
import { Spinner } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

const ManagerReportCrs = (props) => {

  const { mesg, isMobile, isDetail, totalManagers,
    check, overAllManagersData, setOverAllManagersData,
    setCountForManager, counterForMng, setCounterForMng,
    cmpletionText, isLP, courseOrVideo, selectedFilters } = props

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const search = window.location.search;
  const params = new URLSearchParams(search);
  const crsManagersRes = useSelector((state) => state.report?.crsReportManagers);
  const lpManagersRes = useSelector((state) => state.report?.lpManagers);
  // const [overAllManagersData, setOverAllManagersData] = useState([]);


  const [loadSpin, setLoadSpin] = useState(true)


  useEffect(() => {
    // setOverAllManagersData([])
    return (() => {
      dispatch(getCrsReportManagersClear())
    })
  }, [])

  useEffect(() => {
    if (!_.isEmpty(crsManagersRes) || !_.isEmpty(lpManagersRes)) {
      setLoadSpin(false)

    }
  }, [crsManagersRes, lpManagersRes])
  console.log("Data length", overAllManagersData?.length, totalManagers?.total_manager)
  return (
    <section className="manager-section-report progress-box-report">
      <div className="container">
        <div className="row">
          <div className="col-md-12">
            <div className="progess-count-tiel">
              Managers&nbsp;<strong>({totalManagers?.total_manager})</strong>
            </div>
          </div>
        </div>
        <div className="row mt-3">
          {(!_.isEmpty(overAllManagersData)) ? overAllManagersData?.map((m, index) => {
            return (
              <div className="col-md-6 col-lg-4 col-xl-3 col-12 mb-report" key={index}>
                <div className="reopor-box-progess">
                  <div className="progess-profile d-flex">
                    <div className="user-progess-img">
                      <img src={m?.profile_pic} width="48" height="48" />
                    </div>
                    <div className="userprogress-details">
                      <h5 className="user-tiele">{m?.user_name}</h5>
                      <OverlayTrigger
                        key='bottom'
                        placement='bottom'
                        overlay={
                          <Tooltip id={`tooltip-bottom`}>
                            <div
                              style={{
                                color: "white",
                                backgroundColor: "black",
                              }}

                            >{m?.office_name}</div>
                          </Tooltip>
                        }
                      >
                        <p >{m?.office_name}</p>
                      </OverlayTrigger>
                      {/* <p>{m?.office_name}</p> */}
                    </div>
                  </div>
                  <hr />

                  <div class="progress-details">
                    <div class="progess-report-graph">
                      <div class="circlebox">
                        <div
                          className="circularProgress-sm"
                          style={{
                            width: 72,
                            height: 72,
                            position: "relative",
                          }}
                        >
                          <CircularProgressbar
                            value={m?.learning_percentage}
                            strokeWidth={8}
                            styles={buildStyles({
                              pathColor: "#774D9F", //FF9700=yellow
                              trailColor: "#EBEBEB",
                            })
                            }
                          />
                          <div className="centerprogess-con"
                            style={{
                              position: "absolute",
                              top: "1.2rem",
                              width: "72px",
                              textAlign: "center",
                            }}
                          >
                            {true ? (
                              <>
                                <strong
                                  style={{ color: "#774D9F" }}
                                >{`${m?.learning_percentage}%`}</strong>
                                <small>Progress</small>
                              </>
                            ) : (
                              ""
                            )}
                          </div>
                        </div>
                      </div>

                    </div>
                    <div class="progess-count-show-new">
                      <div class="learning-points-new">
                        <strong>{m?.total_completed}/</strong>{m?.total_assigned}
                      </div>
                      <div class="learning-points-name">
                        {cmpletionText}
                      </div>
                    </div>

                  </div>
                  {isDetail ? <div className="prog-link"></div> : <div className="prog-link" onClick={() => {
                    localStorage.setItem('SELECTED_FILTER', JSON.stringify({
                      isLP: (window.location.pathname.includes('/lp-report') || isLP),
                      selectedFilters
                  }))
                    if (isLP) {
                      let url = isMobile ? "/lp-report-rea-mobile-detail" : "/lp-report-rea-detail";
                      url = url + "?id=" + m.uid + "&isCompliance=" + (check ? 1 : 0) + "&isAgent=true";
                      navigate(url)

                    } else {
                      let url = isMobile ? '/compliance-report-agent-detail-mobile' : '/compliance-report-agent-detail';
                      url = url + '?id=' + m.uid + "&isCompliance=" + (check ? 1 : 0) + "&isAgent=true";
                      if(courseOrVideo)
                      {
                        url = url + "&isVideos=true";
                      } 
                      else
                      {
                        url = url + "&isVideos=false";
                      }
                      navigate(url)
                    }
                  }}>
                    View More
                  </div>}

                </div>
              </div>
            );
          }
          )
            :
            <div className="col-md-12">
              <div className="not-found mt-3">
                <div className="interboxes">
                  <img src="/images/telescope.svg" alt="Not Found" />
                  <p> {mesg}</p>
                </div>
              </div>
            </div>
          }
          <div className="col-md-12 mt-3">
            <p className="text-center">
              {overAllManagersData?.length === 0 || (totalManagers?.total_manager === overAllManagersData?.length) ? "" : (totalManagers?.total_manager < 4) ? "" :
                <button
                  type="button"
                  id="number"
                  className="btn btn-primary-complete"
                  onClick={() => {
                    setCountForManager(counterForMng, setCounterForMng);
                    setLoadSpin(true);
                  }
                  }
                >
                  {(loadSpin) ?
                    <div className="d-flex justify-content-center w-100">
                      <Spinner animation="border" />
                    </div>
                    : "Load More"}
                </button>
              }
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}

export default ManagerReportCrs;